/*
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2022-12-02 13:09:28
 * @LastEditors: dudedu
 * @LastEditTime: 2022-12-09 16:16:16
 */
import JSEncrypt from 'jsencrypt';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';

// 公钥
const publicKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA+GSSLQkMiwKP0oVPAzmt
dfP5L0K4zYZ4ggLhF/99RobYqAPNBXqr28D7Guzz7w6Sf98Z6TxNCzCjrEn2rqMs
6a44qYX/NdrgVOFM/wg5pYhdcXwfI2LLGRyJCOSDO/e6qcJn5j1YYqNr0cH60mhX
w9s8DT+HcFaeMNBnWo6tbl2bmUOJaje1ocYKQQxmpeCS9QjuRMico87VqoLsW4vJ
Nkd7E3uFHZeJaKggtP/9n2MCXEDImN5+m670VvRfhPiHE/lDs2eryYK967wbuJRh
BkHrc2j4kVTT+VMlxz/dokqGwSw59nHQyJh0a/IfpWXNTt8nGqcUX3RGXNsfp6Dn
QQIDAQAB`;

// 是否发版
export const RELEASE_JSON_URL = 'https://eda-static-cdn-1300241787.file.myqcloud.com/build/notice.json';

/**
 * 复制文本
 * @param ctx 上下文
 * @param textStr 复制内容
 */
export function copyText(ctx, textStr) {
  const promise = window.navigator.clipboard.writeText(textStr);
  promise
    .then(() => {
      ctx.$message.success(ctx.$t('common.copySuccess'));
    })
    .catch(() => {
      ctx.$message.error(ctx.$t('common.copyFailed'));
    });
}

/**
 * RSA加密
 * @param msg 需要加密的内容
 */
export function rsaEncryption(msg) {
  const option = '';
  const encrypt = new JSEncrypt(option);
  // 添加公钥
  encrypt.setPublicKey(publicKey);
  // rsa加密内容
  return encrypt.encrypt(msg);
}

/**
 * 防抖
 * @param cb 函数
 * @param timer 时间
 */
let timeout = null;

export function debounce(cb, timer) {
  clearTimeout(timeout);
  timeout = setTimeout(cb, timer);
}

/**
 * 保存文件
 * @param fileName 文件名称
 * @param fileBody 文件内容
 * @param option 保存的格式
 */
export function generateFile(fileName, fileBody, option) {
  return new File([fileBody], fileName, option);
}

/**
 * 运行时间处理
 * @param num 秒数
 */
export function ComputeTimeFilter(num) {
  if (typeof num !== 'number') return '-小时';
  if (!num) return '0秒';
  const sec = num % 60;
  const mins = (num - sec) / 60;
  if (mins < 60) {
    return `${mins}分${sec}秒`;
  }
  const min = mins % 60;
  const hours = (mins - min) / 60;
  if (hours < 24) {
    return `${hours}小时${min}分${sec}秒`;
  }
  const hour = hours % 24;
  const day = Math.floor(hours / 24);
  return `${day}天${hour}小时${min}分${sec}秒`;
}

/**
 * 默认时间格式化
 */
export function processTime(val) {
  if (!val || val === 0) {
    return '-';
  }
  return dayjs(val * 1000).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * ISO8601时间格式化
 */
export function processISO8601Time(val) {
  if (!val || val === 0) {
    return '-';
  }
  // 创建 Date 对象
  // const date = new Date(val);
  // 获取本地时间字符串
  const localDateString = dayjs(val).format('YYYY-MM-DD HH:mm:ss');
  return localDateString;
}

export function processCharge(type) {
  switch (type) {
    case 'POSTPAID_BY_HOUR':
      return '按量计费';
    case 'PREPAID':
      return '包年包月';
    default:
      return '-';
  }
}

// 开发环境默认地区 广州
export function defaultFilterRegion() {
  // if (process.env.NODE_ENV === 'development') {
  //   return 'ap-chengdu';
  // }
  // return 'ap-nanjing';

  return '';
}

// 导出数据
export function exportData(result, name) {
  const worksheet = XLSX.utils.json_to_sheet(result);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const binaryWorkbook = XLSX.write(workbook, { type: 'binary', bookType: 'xlsx' });
  const blob = new Blob([s2ab(binaryWorkbook)], { type: 'application/octet-stream' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${name}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function s2ab(binaryString) {
  const buffer = new ArrayBuffer(binaryString.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < binaryString.length; i++) {
    view[i] = binaryString.charCodeAt(i) & 0xff;
  }
  return buffer;
}

// 筛选磁盘类型
export function filterDiskType(diskType) {
  let label = '';
  switch (diskType) {
    case 'CLOUD_BASIC':
      label = '普通云硬盘';
      break;
    case 'CLOUD_PREMIUM':
      label = '高性能云硬盘';
      break;
    case 'CLOUD_BSSD':
      label = '通用型SSD云硬盘';
      break;
    case 'CLOUD_SSD':
      label = 'SSD云硬盘';
      break;
    case 'CLOUD_HSSD':
      label = '增强型SSD云硬盘';
      break;
    case 'CLOUD_TSSD':
      label = '极速型SSD云硬盘';
      break;
    default:
  }
  return label;
}

// 筛选计费方式
export function filterInstanceChargeType(instanceChargeType) {
  let label = '';
  switch (instanceChargeType) {
    case 'POSTPAID_BY_HOUR':
      label = '按量计费';
      break;
    case 'PREPAID':
      label = '包年包月';
      break;
    case 'SPOTPAID':
      label = '竞价付费';
      break;
    default:
  }
  return label;
}

// 筛选实例状态
const instanceStateList = [
  { label: '创建中', value: 'PENDING', color: '#165BCF' },
  { label: '创建失败', value: 'LAUNCH_FAILED', color: '#D12734' },
  { label: '运行中', value: 'RUNNING', color: '#0BC740' },
  { label: '已关机', value: 'STOPPED', color: '#165BCF' },
  { label: '开机中', value: 'STARTING', color: '#165BCF' },
  { label: '关机中', value: 'STOPPING', color: '#165BCF' },
  { label: '重启中', value: 'REBOOTING', color: '#165BCF' },
  { label: '停止待销毁', value: 'SHUTDOWN', color: '#D12734' },
  { label: '销毁中', value: 'TERMINATING', color: '#D12734' },
];

export function filterInstanceState(instanceState) {
  let label = '';
  label = instanceStateList.filter(item => item.value === instanceState);
  return label[0] || [];
}

// 筛选环境状态
const envStatusList = [
  { label: '初始化', value: 0 },
  { label: '创建中', value: 1 },
  { label: '创建失败', value: 2 },
  { label: '创建成功', value: 3 },
  { label: '销毁中', value: 4 },
  { label: '清理数据中', value: 5 },
  { label: '清理数据完成', value: 6 },
  { label: '清理数据失败', value: 7 },
  { label: '销毁完成', value: 8 },
];

export function filterEnvStatus(envStatus) {
  let label = '';
  label = envStatusList.filter(item => item.value === envStatus);
  return label[0]?.label || '-';
}

// 调度器list 工作负载管理器 0=slurm22.05 1=IBM Spectrum LSF Community Edition 10.1 2=IBM Spectrum LSF 10.1.0
export const workloadManagerList = [
  { text: 'slurm22.05', value: 0 },
  { text: 'IBM Spectrum LSF Community Edition 10.1', value: 1 },
  { text: 'OpenPBS 23.06.06', value: 3 },
  { text: 'Openlava 4.0', value: 4 },
  { text: 'Sun Grid Engine(SGE) 8.1.9', value: 5 },
];

export function filterWorkloadManager(workloadManager) {
  let label = '';
  label = workloadManagerList.filter(item => item.value == workloadManager);
  return label[0]?.text || '-';
}

// 审批状态 1- 审批中 2-失败 3-成功
export const applyStatusList = [
  { label: '所有状态', value: 0 },
  { label: '审批中', value: 1 },
  { label: '已拒绝', value: 2 },
  { label: '已通过', value: 3 },
  { label: '已撤回', value: 4 },
  { label: '已过期', value: 5 },
  { label: '提交审批中', value: 6 },
  { label: '提交失败', value: 7 },
];

export function filterApplyStatus(applyStatus) {
  let label = '';
  label = applyStatusList.filter(item => item.value == applyStatus);
  return label[0]?.label || '-';
}

// 审批类型 0-所有 1-添加成员 2-下载文件
const applySceneList = [
  { label: '所有', value: 0 },
  { label: '加入团队', value: 1 },
  { label: '下载文件', value: 2 },
];

export function filterApplyScene(scene) {
  let label = '';
  label = applySceneList.filter(item => item.value == scene);
  return label[0]?.label || '-';
}

// CFS存储类型 0-通用标准型存储 1-通用性能型存储 2-Turbo标准型 3-Turbo性能型
export const cfsStorageTypeList = [
  { text: '通用标准型存储', value: 'SD' },
  { text: '通用性能型存储', value: 'HP' },
  { text: 'Turbo标准型', value: 'TB' },
  { text: 'Turbo性能型', value: 'TP' },
];

// 过滤CFS存储类型 CFS存储类型 0-通用标准型存储 1-通用性能型存储 2-Turbo标准型 3-Turbo性能型
export function filterCfsStorageTypeList(scene) {
  let label = '';
  label = cfsStorageTypeList.filter(item => item.value == scene);
  return label[0]?.text || '-';
}

// 地区列表
export const regionList = [
  { value: 'ap-nanjing', label: '南京' },
  { value: 'ap-shanghai', label: '上海' },
  { value: 'ap-beijing', label: '北京' },
  { value: 'ap-guangzhou', label: '广州' },
  { value: 'ap-chengdu', label: '成都' },
  { value: 'ap-chongqing', label: '重庆' },
];

// 地区列表 转义地区
export function filterRegionList(scene) {
  let label = '';
  label = regionList.filter(item => item.value == scene);
  return label[0]?.label || '-';
}

// 地区列表
export const providerList = [
  { label: '阿里云', value: 'aliyun' },
  { label: '华为云', value: 'huaweicloud' },
  { label: '火山云', value: 'volcengine' },
];

export function filterProviderList(scene) {
  let label = '';
  label = providerList.filter(item => item.value == scene);
  return label[0]?.label || '-';
}

// 多云格式化 region name
// 提取多云的区域名称
export function extractRegionName(regionName) {
  const match = regionName.match(/[（(](.*?)[）)]/);
  return match ? match[1] : regionName;
}

// 续费标签列表
export const renwFlagList = [
  { label: '到期时间提醒且自动续费', value: 'NOTIFY_AND_AUTO_RENEW' },
  { label: '到期时间提醒不自动续费', value: 'NOTIFY_AND_MANUAL_RENEW' },
  { label: '到期时间不提醒不自动续费', value: 'DISABLE_NOTIFY_AND_MANUAL_RENEW' },
];

export function filterRenwFlagList(scene) {
  let label = '';
  label = renwFlagList.filter(item => item.value == scene);
  return `( ${label[0]?.label} )` || '';
}

// // 计算集群 任务管理 状态 管理
// export const taskManageStatusList = [
//   { label: '到期时间提醒且自动续费', value: 'NOTIFY_AND_AUTO_RENEW' },
//   { label: '到期时间提醒不自动续费', value: 'NOTIFY_AND_MANUAL_RENEW' },
//   { label: '到期时间不提醒不自动续费', value: 'DISABLE_NOTIFY_AND_MANUAL_RENEW' },
// ];
//
// export function filterTaskManageStatusList(scene) {
//   let label = '';
//   label = taskManageStatusList.filter(item => item.value == scene);
//   return `( ${label[0]?.label} )` || '';
// }

/**
 * 根据文件扩展名获取MIME类型
 */
export function getMimeType(filename) {
  const ext = filename.split('.').pop()
    .toLowerCase();
  console.log(ext, 'extextextext');
  const mimeTypes = {
    // 文本文件
    txt: 'text/plain',
    html: 'text/html',
    css: 'text/css',
    js: 'application/javascript',
    json: 'application/json',
    xml: 'application/xml',

    // 图片文件
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    bmp: 'image/bmp',
    svg: 'image/svg+xml',
    ico: 'image/x-icon',

    // 音频文件
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    ogg: 'audio/ogg',
    m4a: 'audio/mp4',

    // 视频文件
    mp4: 'video/mp4',
    avi: 'video/x-msvideo',
    mov: 'video/quicktime',
    wmv: 'video/x-ms-wmv',
    flv: 'video/x-flv',

    // 文档文件
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',

    // 压缩文件
    zip: 'application/zip',
    rar: 'application/x-rar-compressed',
    '7z': 'application/x-7z-compressed',
    tar: 'application/x-tar',
    gz: 'application/gzip',

    // 其他常见文件
    exe: 'application/x-msdownload',
    dll: 'application/x-msdownload',
    iso: 'application/x-iso9660-image',
  };

  return mimeTypes[ext] || 'application/octet-stream';
}
